import { IConfiguration } from '../models/app/IConfiguration';

export const CONFIGURATION: IConfiguration = {
	components: {
		app: {
			summaryBlocks: {
				props: {
					breakpoints: [
						{
							size: 'xsmall',
							modifier: 'only',
							props: {
								itemsPerRow: 1,
							},
						},
						{
							size: 'small',
							modifier: 'up',
							props: {
								itemsPerRow: 4,
							},
						},
					],
				},
				queries: {
					breakpoints: [
						{},
						{
							props: {
								itemsPerRow: {
									queryOptionsType: 'commentaries',
									entityType: 'CLSS',
									key: 'investment_objective',
									transforms: [
										{
											transformOptionsType: 'switch',
											switchOptions: {
												cases: [
													{
														id: 'Key Information Undefined',
														conditional: {
															conditions: [
																{
																	value: undefined,
																},
															],
														},
														response: 1,
													},
												],
												defaultResponse: 4,
											},
										},
									],
								},
							},
						},
					],
					blocks: [
						{
							key: {
								queryOptionsType: 'none',
								value: 'nav',
							},
							title: {
								queryOptionsType: 'none',
								value: 'NAV',
							},
							subtitle: {
								queryOptionsType: 'statistics',
								entityType: 'CLSS',
								code: 'valuation',
								key: 'date',
								index: 0,
								collectionItemValueConditional: {
									conditions: [
										{
											field: 'label',
											operator: '=',
											value: 'NAV',
										},
									],
								},
								format: {
									type: 'date',
									options: {
										day: '2-digit',
										month: '2-digit',
										year: 'numeric',
										placeholderText: 'as of {date}',
										placeholderKey: 'date',
									},
								},
							},
							value: {
								queryOptionsType: 'statistics',
								entityType: 'CLSS',
								code: 'valuation',
								key: 'value',
								index: 0,
								collectionItemValueConditional: {
									conditions: [
										{
											field: 'label',
											operator: '=',
											value: 'NAV',
										},
									],
								},
								format: {
									type: 'currency',
									options: {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
									},
								},
								subQueries: [
									{
										queryId: 'currency',
										queryOptionsType: 'property',
										entityType: 'CLSS',
										code: 'share_class_currency',
									},
								],
							},
							tooltip: {
								title: {
									content: {
										queryOptionsType: 'disclaimers',
										key: 'de_nav_disclaimer',
									},
								},
							},
							blankDataOptions: {
								placeholder: '-',
							},
						},
						{
							key: {
								queryOptionsType: 'none',
								value: 'aum',
							},
							title: {
								queryOptionsType: 'none',
								value: 'AUM',
							},
							subtitle: {
								queryOptionsType: 'statistics',
								entityType: 'CLSS',
								code: 'valuation',
								key: 'date',
								index: 0,
								collectionItemValueConditional: {
									conditions: [
										{
											field: 'label',
											operator: '=',
											value: 'AUM',
										},
									],
								},
								format: {
									type: 'date',
									options: {
										day: '2-digit',
										month: '2-digit',
										year: 'numeric',
										placeholderText: 'as of {date}',
										placeholderKey: 'date',
									},
								},
							},
							value: {
								queryOptionsType: 'statistics',
								entityType: 'CLSS',
								code: 'valuation',
								key: 'value',
								index: 0,
								collectionItemValueConditional: {
									conditions: [
										{
											field: 'label',
											operator: '=',
											value: 'AUM',
										},
									],
								},
								format: {
									type: 'currency',
									options: {
										minimumFractionDigits: 2,
										maximumFractionDigits: 2,
										thresholdSeparator: ' ',
										numberThresholds: [
											{
												value: 1000000,
												text: 'million',
											},
											{
												value: 1000000000,
												text: 'billion',
											},
										],
									},
								},
								subQueries: [
									{
										queryId: 'currency',
										queryOptionsType: 'property',
										entityType: 'CLSS',
										code: 'share_class_currency',
									},
								],
							},
							blankDataOptions: {
								placeholder: '-',
							},
						},
						{
							key: {
								queryOptionsType: 'none',
								value: 'srri',
							},
							dataType: {
								queryOptionsType: 'none',
								value: 'risk-rating',
							},
							title: {
								queryOptionsType: 'none',
								value: 'Risk and reward profile',
							},
							riskRatingProps: {
								labels: {
									bottom: {
										left: {
											queryOptionsType: 'none',
											value: 'Lower Risk',
										},
										right: {
											queryOptionsType: 'none',
											value: 'Higher Risk',
										},
									},
								},
								value: {
									queryOptionsType: 'property',
									entityType: 'CLSS',
									code: 'srri',
								},
							},
							tooltip: {
								title: {
									content: {
										queryOptionsType: 'disclaimers',
										key: 'srri',
									},
								},
							},
							blankDataOptions: {
								showBlank: false,
							},
						},
						{
							key: {
								queryOptionsType: 'none',
								value: 'mstar',
							},
							dataType: {
								queryOptionsType: 'none',
								value: 'morningstar-rating',
							},
							title: {
								queryOptionsType: 'none',
								value: 'Morningstar Rating ™',
							},
							morningstarRatingProps: {
								morningStarRating: {
									queryOptionsType: 'property',
									entityType: 'CLSS',
									code: 'morningstar_rating',
								},
							},
							blankDataOptions: {
								showBlank: false,
							},
						},
					],
				},
			},
		},
	},
};
